/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types'
import { USBInputBase } from '@usb-shield/react-forms-base/dist/esm'
import { useEffect, useRef, useState } from 'react'

/**
 * PreAuthTokensInput
 * @param  {array} preAuthTokens form fields to display
 * @param  {function} handleOnChange Callback function for handle change
 * @param {array} errors errors for form validation
 * @returns {HTMLElement}
 */
const PreAuthTokensInput = ({
  preAuthTokens,
  handleOnChange,
  errorCount,
  payeeId,
  inlineMsg,
  apierror
}) => (
  <>
    {preAuthTokens &&
      preAuthTokens.length > 0 &&
      preAuthTokens.map((data) => {
        let maxLength = '32'
        let inputMode = 'text'
        let pattern = `/^[a-zA-Z0-9_@!+#.$,%^ *-]{32}$/`
        const schemaKey = `${payeeId}_${data.tokenDescription}_${data.tokenType}`
        const accountinfo =
          (apierror &&
            apierror?.find((info) => info.extensions?.help === payeeId)) ||
          {}
        const verifyPayload =
          accountinfo?.extensions?.variables?.verifyPotentialPayeeRequest
            ?.verifyPayeesParameters
        const verifyParameters = verifyPayload?.find(
          (payload) => payload?.payeeID === payeeId
        )
        const { verificationTokens } = verifyParameters || {}
        const { tokenValue: initVal } =
          (verificationTokens &&
            verificationTokens?.find(
              (val) => val.tokenDescription === data.tokenDescription
            )) ||
          {}

        const [isError, setIsError] = useState(inlineMsg)
        useEffect(() => {
          if (inlineMsg) setIsError(true)
        }, [inlineMsg])
        if (
          data &&
          data.tokenType &&
          data.tokenType.toLowerCase() === 'number'
        ) {
          inputMode = 'decimal'
          pattern = `/^[0-9]{32}$/`
          maxLength = 12
        }
        const inputId = `${data?.tokenDescription}${payeeId}`
        const getErrorMsg = (description) => {
          if (data?.tokenDescription === 'Account Number') {
            return inlineMsg
          }
          return `please enter valid ${description}`
        }
        const validationFunction = (value) => {
          if ((isError && value === initVal) || (isError && value === '')) {
            setIsError(true)
            return 114
          }
          if (value.length === 0) {
            setIsError(true)
            return 121
          }
          return 0
        }
        return (
          <>
            {(inputMode === 'text' ||
              inputMode === 'password' ||
              inputMode === 'tel' ||
              inputMode === 'decimal' ||
              inputMode === 'number' ||
              inputMode === 'date') && (
              <USBInputBase
                inputType={inputMode}
                inputMode={inputMode}
                ref={useRef()}
                labelText={data?.tokenDescription}
                inputName={inputId}
                autocomplete="off"
                maxlength={maxLength}
                pattern={pattern}
                callbackFrequency="every"
                id={schemaKey}
                statusUpdateCallback={(inputObj) => {
                  // updateCallback(inputObj)
                  const { inputValue, inputRef } = inputObj
                  inputRef?.current
                    ?.querySelector('input')
                    ?.classList.add('glance_masked')
                  setIsError(false)
                  handleOnChange({
                    name: schemaKey,
                    value: inputValue,
                    errorName: schemaKey
                  })
                }}
                errorMessages={{
                  default: `please enter ${data?.tokenDescription}`,
                  114: getErrorMsg(data?.tokenDescription),
                  121: `please enter ${data?.tokenDescription}`
                }}
                // errorMessages={`Please enter your ${data?.tokenDescription}`}
                showErrorMessageFrequency="every"
                showFilterErrors
                dynamicErrorCount={isError ? 1 : errorCount}
                key={inlineMsg ? `${schemaKey} - ${inlineMsg}` : schemaKey}
                // dynamicValue={initVal?.toString()}
                validationFunction={validationFunction}
                initValue={initVal}
              />
            )}
          </>
        )
      })}
  </>
)
PreAuthTokensInput.propTypes = {
  preAuthTokens: PropTypes.arrayOf(PropTypes.any).isRequired,
  handleOnChange: PropTypes.func.isRequired,
  payeeId: PropTypes.string.isRequired,
  inlineMsg: PropTypes.string,
  apierror: PropTypes.arrayOf(PropTypes.any),
  errorCount: PropTypes.bool.isRequired
}
PreAuthTokensInput.defaultProps = {
  inlineMsg: '',
  apierror: []
}

export default PreAuthTokensInput
